define('YearMakeModel.Searcher.View',
    [
        'year_make_model_searcher.tpl',
        'SCView',
        'jQuery',
        'underscore'
    ],

    function (
        year_make_model_searcher_tlp,
        SCViewComponent,
        jQuery,
        _
    ) {

        'use strict'

        var SCView = SCViewComponent.SCView;

        function YearMakeModelSearcher(options) {
            SCView.call(this);
            this.options = options || {};
            this.template = year_make_model_searcher_tlp;
            this.initialize = function initialize(options) {
                this.data = SC.ENVIRONMENT.rareparts_ymm;
                this.selectedYear = null;
                this.selectedMake = null;
                this.selectedModel = null;
            }
            this.initialize(options);

            this.getYearsToShow = function () {
                var ret = []
                var self = this;
                _.each(this.data, function (year) {
                    var obj = {
                        year: year.year,
                        id: year.id,
                        selected: self.selectedYear == year.id ? true : false
                    }
                    ret.push(obj);
                });
                return ret;
            };

            this.getMakesToShow = function (makes) {
                var ret = []
                var self = this;
                _.each(makes, function (make) {
                    var obj = {
                        make: make.name,
                        id: make.id,
                        selected: self.selectedMake == make.id ? true : false
                    }

                    ret.push(obj);
                });
                return ret;
            }

            this.getModelsToShow = function (models) {
                var ret = []
                _.each(models, function (model) {
                    var obj = {
                        model: model.name,
                        id: model.id
                    }
                    ret.push(obj);
                });
                return ret;
            }

            this.getMakesByYear = function (yearId) {
                var yearObj = _.find(this.data, { id: yearId });
                return yearObj ? yearObj.makes : null;
            }

            this.getModelsByMake = function (yearId, makeId) {
                var yearObj = _.find(this.data, { id: yearId });
                var makeObj = _.find(yearObj.makes, { id: makeId });
                return makeObj ? makeObj.models : null;
            };

            this.selectOption = function (e) {
                e.preventDefault();
                e.stopPropagation();
                var target = e.target.name;
                if (target == 'year') {
                    var yearId = jQuery(e.target).val();
                    this.selectedYear = yearId == 'default' ? null : yearId;
                    this.enableMakeSelection(yearId);
                } else if (target == 'make') {
                    var yearId = jQuery('#year').val();
                    var makeId = jQuery(e.target).val();
                    this.selectedMake = makeId == 'default' ? null : makeId;
                    this.enableModelSelection(yearId, makeId);
                } else {
                    var modelId = jQuery(e.target).val();
                    this.selectedModel = modelId == 'default' ? null : modelId;
                    if (!this.selectedModel) {
                        jQuery('#model').prop('disabled', true);
                    }
                    this.redirectToPLP();
                }
            };

            this.enableMakeSelection = function (yearId) {
                // RP 2026-10-22: a new Year starts Make and Model over. Before this,
                // the previous Year/Make's model list stayed in the Model dropdown
                // (still enabled) until a page reload.
                this.selectedMake = null;
                this.selectedModel = null;
                this.models = null;
                jQuery('#make').prop('disabled', false);
                if (!!this.selectedYear) {
                    var makes = this.getMakesByYear(yearId);
                    this.makes = this.getMakesToShow(makes);
                    this.clearDropDown('make');
                    this.clearDropDown('model');
                    this.render();
                } else {
                    // blank "-- Year --": empty both lists, not just grey them out
                    this.makes = null;
                    this.clearDropDown('make');
                    this.clearDropDown('model');
                    this.render();
                }

            };

            this.enableModelSelection = function (yearId, modelId) {
                // RP 2026-10-22: a new Make starts Model over, and the blank
                // "-- Make --" choice empties the Model list. It used to disable
                // the Make dropdown itself, so no other make could be picked.
                this.selectedModel = null;
                var makes = this.getMakesByYear(yearId);
                this.makes = this.getMakesToShow(makes);
                if (!!this.selectedYear && !!this.selectedMake) {
                    var models = this.getModelsByMake(yearId, modelId);
                    this.models = this.getModelsToShow(models);
                } else {
                    this.models = null;
                }
                this.clearDropDown('model');
                this.render();
            };

            this.redirectToPLP = function () {
                var year = _.find(this.data, { id: this.selectedYear });
                var makeObj = _.find(year.makes, { id: this.selectedMake });
                var modelObj = _.find(makeObj.models, { id: this.selectedModel });
                var containDashOnModel = modelObj.name.indexOf('-') != -1 ? true : false;
                var containDashOnMake = makeObj.name.indexOf('-') != -1 ? true : false;
                if (year && makeObj && modelObj) {
                    var valuesForUrl = [];
                    valuesForUrl.push(year.year.toString());
                    if(containDashOnMake){
                        var urlMake = makeObj.url.replace(/[,;]/gi, '').replace(/\s+/g, '-').replace(/[~]/g, '-');
                        urlMake = urlMake.replace('-', '~');
                        valuesForUrl.push(urlMake);
                    }else{
                        valuesForUrl.push(makeObj.url.replace(/[,;]/gi, '').replace(/\s+/g, '-').replace(/[~]/g, '-'));
                    }
                    if(containDashOnModel){
                        var urlModel = modelObj.url.replace(/[,;]/gi, '').replace(/\s+/g, '-').replace(/[~]/g, '-');
                        urlModel = urlModel.replace('-', '~');
                        valuesForUrl.push(urlModel);
                    }else{
                        valuesForUrl.push(modelObj.url.replace(/[,;]/gi, '').replace(/\s+/g, '-').replace(/[~]/g, '-'));
                    }
                    var url = '/search?make=' + valuesForUrl[1] + '&model=' + valuesForUrl[2] + '&year=' + valuesForUrl[0];
                    Backbone.history.location.assign(url);
                }
            }

            this.clearDropDown = function (elementId) {
                jQuery('#' + elementId).empty();
            }

            this.replaceableCharacters = [
                { character: '-', encodedValue: '~' },
                { character: '/', encodedValue: '-SLASH-' },
                { character: '&(?!amp;)', encodedValue: '-AND-' },
                { character: ',', encodedValue: '%2C' },
                { character: "'", encodedValue: '%27' },
                { character: ' ', encodedValue: '-' },
            ]
        }

        YearMakeModelSearcher.prototype = Object.create(SCView.prototype);

        YearMakeModelSearcher.prototype.constructor = YearMakeModelSearcher;

        YearMakeModelSearcher.prototype.getEvents = function getEvents() {
            return {
                'change [data-action="select-data"]': 'selectOption'
            };
        }

        YearMakeModelSearcher.prototype.getContext = function getContext() {

            return {
                years: this.getYearsToShow(),
                makes: this.makes ? this.makes : false,
                models: this.models ? this.models : false,
                disableMakes: this.makes ? false : true,
                disableModels: this.models ? false : true,
            };

        }
        return YearMakeModelSearcher;
    }
);
